import { render, staticRenderFns } from "./exhibition-material.vue?vue&type=template&id=43423846&scoped=true&"
import script from "./exhibition-material.vue?vue&type=script&lang=js&"
export * from "./exhibition-material.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-material.vue?vue&type=style&index=0&id=43423846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43423846",
  null
  
)

export default component.exports